import { DragInterfaceContext, DragGeometryContext } from './MouseDragProvider';

import { DragBoxHoveredCellsDispatch } from './DragBoxHoverProvider';

import { useRef, useContext, useCallback } from 'react';
import useEditorDispatch from './useEditorDispatch';
import { MouseAvailabilityContext } from './MouseFocusProvider';

function getDragRect(start,end){
  let left = Math.min(start[0],end[0]);
  let right = Math.max(start[0],end[0]);

  let top = Math.min(start[1],end[1]);

  let bottom = Math.max(start[1],end[1]);

  let width = Math.abs(right - left);
  let height = Math.abs(bottom - top);

  return { left, top, width, height }
}

export default function DragBoxLayer({children}){


  let { startDrag } = useContext(DragInterfaceContext);
  const { isMouseAvailable } = useContext(MouseAvailabilityContext);

  const onFigureInteractionEvent = useEditorDispatch();

  let dispatchHoveredRects = useContext(DragBoxHoveredCellsDispatch);
  let geo = useContext(DragGeometryContext);
  
  
  let cropBox;

  const dragActive = useRef(false);

  if( dragActive.current && geo && geo.start && geo.end ){
    let { start, end } = geo;
    let dragRect = getDragRect(start,end);
    let cropBoxStyle = {
      pointerEvents:'none',
      border:'2px solid #eee',
      position:'fixed',
      background:'black',
      opacity:0.3,
      ...dragRect
    }

    cropBox = <div style={cropBoxStyle}/>
  }

  const onMouseDown = useCallback(event => {


    if( event.canDrag === false || !isMouseAvailable() ){
      return;
    }

      if( event.buttons === 1 ){

        dragActive.current = true;
        let started = startDrag({
          event,
          mouseFocusControllerId:"dragBox",
          onMouseMove:(start,end,info) => {

            console.log("ALSO MOVING DRAG BOX");

            let newSelectionRect = getDragRect(start,end);
            let rectIntersectionList = getRectIntersectionList(newSelectionRect);
            let cellLocations = rectIntersectionList.map(grid => grid.split('-').slice(1).map(Number));

            dispatchHoveredRects(cellLocations);

          },
          onDragEnd:(start,end,info,event) => {

            dragActive.current = false;

            let newSelectionRect = getDragRect(start,end);
            let intersectionIds = getRectIntersectionList(newSelectionRect);

            let cells = intersectionIds.map( id => id.split('-').filter((x,ii)=>ii>0).map(
              item => Number(item)
            ).filter(xx => !isNaN(xx)));


            onFigureInteractionEvent({
              event,
              type:"selectCells",
              cells
            })

            dispatchHoveredRects([]);

            


          }
        })
        console.log({started});
      }
  },[onFigureInteractionEvent,dispatchHoveredRects,startDrag])


  return (

    <div onMouseDown={onMouseDown}
      id="figure-container" style={{
      minHeight:0,
      minWidth:0,
    }} class="flex-expand sg-col">
      {children}
      {cropBox}
    </div>

  )




}

const doRectsIntersect = function(r1, r2){
  let res = !(r2.left > r1.right || 
    r2.right < r1.left || r2.top > r1.bottom ||
    r2.bottom < r1.top);

  return res;
}

const getRectIntersectionList= function(selectionRect){

  if( Object.values(selectionRect).includes(NaN) ){
    return [];
  }

  let gridItems = Array.from(document.querySelectorAll('td[id*=grid-]'));


  let comparableSelectionRect = {
    ...selectionRect,
    right:selectionRect.left + selectionRect.width,
    bottom:selectionRect.top + selectionRect.height
  }



  let intersectingIds = [];

  gridItems.forEach( item => {
    let br = item.getBoundingClientRect();
    if( doRectsIntersect(comparableSelectionRect, br) ){
      intersectingIds.push( item.id );
    }
  })

  return intersectingIds;

}

